/**
 * @imports
 */
import * as QuantumJS from '@webqit/quantum-js';
import init from './init.js';

/**
 * @init
 */
init.call( window, QuantumJS );